import { useDialog } from 'muibox';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import { handleHttpError } from '../utils/common';
import useAxios from './useAxios';
import { OnlyFansMetricType } from './useSextforceMetricsCampaignsOverview';

export type SextforceMetricsCountersLastOfEveryMonth = {
    _id: string;
    countTransitions?: number;
    countSubscribers?: number;
    claimsCount?: number;
    subscribeCounts?: number;
    yearMonth: string;
    initialTransitionsCount?: number;
    newTransitionsCount?: number;
    initialClaimsCount?: number;
    newClaimsCount?: number;
    initialSubscribersCount?: number;
    newSubscribersCount?: number;
};

const useSextforceMetricsCountersLastOfEveryMonth = (
    subscriberId: string | undefined | null,
    metricId: string | undefined | null,
    metricType: OnlyFansMetricType | undefined | null,
    staggerPreviousStepReady: boolean = true,
) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const dialog = useDialog();
    const axios = useAxios();

    const fetchData = async (): Promise<SextforceMetricsCountersLastOfEveryMonth[] | null> => {
        const query: string = `${settingsContext.routes.metrics.base}${subscriberId}/${
            metricType === 'promoCampaign' ? 'promocampaigns' : 'trials'
        }/${metricId}/counters/lastOfMonth`;

        const data = await axios
            .get(query)
            .then(response => response.data)
            .catch(error => {
                console.error(error);
                handleHttpError(error, dialog);
            });

        return data;
    };

    return useQuery(['metricsCountersLastOfEveryMonth', subscriberId, metricId], () => fetchData(), {
        refetchOnWindowFocus: false,
        // 1 hour
        staleTime: 60 * 1000 * 60,
        enabled: Boolean(
            userContext.jwtToken && settingsContext.apiKey && subscriberId && metricId && metricType && staggerPreviousStepReady,
        ),
    });
};

export default useSextforceMetricsCountersLastOfEveryMonth;
